import { Card, Col, Row, Typography } from "antd";
import { StyleSheet } from "../../../StyleSheet";
import { useCallback } from "react";
const { Text } = Typography;

interface InfoCardProps {
    price: string
    vigency: number;
}

const RechargePaymentAmount = (props: InfoCardProps) => {
    const { price, vigency } = props;
    const formatter = Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN" });

    const formatMonto = useCallback((monto: string) => {
        const montoNumerico = parseFloat(monto);

        // Verificar si es un número válido
        if (isNaN(montoNumerico)) {
            return monto;
        }

        // Formatear el número
        return formatter.format(montoNumerico);
    }, [formatter]);

    return (
        <Card style={styles.rowRoot} bodyStyle={{ padding: 10 }}>
            <Row>
                <Col style={styles.colView} sm={24} md={15}>
                    <Text style={styles.textTitle}>{"Monto a Recargar"}</Text>
                </Col>
                <Col sm={24} md={9}>
                    <Row>
                        <Col xs={24} style={styles.secondColView}>
                            <div style={styles.rowView}>
                                <Text
                                    style={styles.textPaymentAmount}
                                >
                                    {formatMonto(price)}
                                </Text>
                            </div>
                        </Col>
                        <Col xs={24} style={styles.secondColView}>
                            <Text style={styles.textDescription}>
                                {(vigency > 0) && (
                                    `Vigencia ${vigency} ${vigency === 1 ? "día" : "días"}`
                                )}
                            </Text>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Card>
    );
};

const styles = StyleSheet.create({
    rowRoot: {
        backgroundColor: "#0055c2",
        padding: 0,
        borderRadius: 15,
        boxShadow: "0px 0px 8px #00000029",
    },
    textTitle: {
        fontSize: 20,
        color: "white",
        fontWeight: 600,
    },
    textDescription: {
        color: "white",
    },
    colView: {
        display: 'flex',
        alignItems: 'center',
        paddingLeft: 20
    },
    secondColView: {
        display: 'flex',
        justifyContent: 'center'
    },
    rowView: {
        display: 'flex',
        flexDirection: 'row'
    },
    textPaymentAmount: {
        color: "#ffffff",
        fontSize: 25,
        fontWeight: 600,
    },
    textPaymentCents: {
        color: "#ffffff",
        fontSize: 16,
        paddingTop: 2,
        fontWeight: 600,
    },
});

export default RechargePaymentAmount;
